import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));  //searching for root element and creating a react root
root.render(
    <App/>  //needs to remove strictmode for making react-tooltip work
);